document.addEventListener("DOMContentLoaded", function() {
    const form = document.getElementById("ContactForm");
    const addRowBtn = document.getElementById("addRowBtn");
    const productRowsContainer = document.getElementById("productRowsContainer");
    let rowCount = 1;

    // Add new product row
    addRowBtn.addEventListener("click", function() {
        rowCount++;
        const newRow = document.createElement("div");
        newRow.className = "products-grid-form";
        newRow.innerHTML = `
            <div class="form-group">
                <label for="sku${rowCount}">Product Code (SKU)</label>
                <input name="contact[sku${rowCount}]" id="sku${rowCount}" type="text" placeholder="e.g., NLK10000">
            </div>
            <div class="description-quantity-group">
                <div class="form-group description">
                    <label for="description${rowCount}">Description</label>
                    <input name="contact[description${rowCount}]" id="description${rowCount}" type="text">
                </div>
                <div class="form-group">
                    <label for="quantity${rowCount}" style="text-align:center">Quantity</label>
                    <div class="quantity-selector">
                        <button type="button" class="quantity-decrease">-</button>
                        <input readonly value="0" name="contact[quantity${rowCount}]" id="quantity${rowCount}" type="text">
                        <button type="button" class="quantity-increase">+</button>
                    </div>
                </div>
            </div>
        `;
        productRowsContainer.appendChild(newRow);

        // Add event listeners to new quantity buttons
        addQuantityButtonListeners(newRow);
    });

    // Add event listeners to quantity buttons
    function addQuantityButtonListeners(container) {
        const decreaseButtons = container.querySelectorAll(".quantity-decrease");
        const increaseButtons = container.querySelectorAll(".quantity-increase");
        
        decreaseButtons.forEach(button => {
            button.addEventListener("click", function() {
                const input = this.nextElementSibling;
                let value = parseInt(input.value);
                if (value >= 10) {
                    input.value = value - 10;
                }
            });
        });

        increaseButtons.forEach(button => {
            button.addEventListener("click", function() {
                const input = this.previousElementSibling;
                let value = parseInt(input.value);
                input.value = value + 10;
            });
        });
    }

    // Initial quantity button listeners
    addQuantityButtonListeners(document);

    // Form submission handler
    form.addEventListener("submit", function(event) {
        event.preventDefault();

        const formData = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open("POST", form.action, true);
        xhr.setRequestHeader("Accept", "application/json");

        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    // Handle successful submission
                    alert("Form submitted successfully!");
                    form.reset();
                } else {
                    // Handle errors without alert
                    console.error("Form submission failed:", xhr.responseText);
                }
            }
        };

        xhr.send(formData);
    });
});
